import { SpinnerSize } from './Spinner.types';

export const SPINNER_SIZE_IN_PX = {
  [SpinnerSize.XS]: '16px',
  [SpinnerSize.S]: '20px',
  [SpinnerSize.M]: '24px',
  [SpinnerSize.L]: '48px',
  [SpinnerSize.XL]: '64px',
};
